export default {
  // Primary brand colors - slate-900 dark theme
  primary: '#0F172A',        // slate-900 (dark navy/slate)
  secondary: '#14B8A6',      // teal-500 (turquoise)
  accent: '#0D9488',         // teal-600 (darker teal accent)
  
  // Background colors
  background: '#0F172A',     // slate-900 dark background
  backgroundLight: '#F9FAFB', // gray-50 light background
  cardBg: '#FFFFFF',         // Pure white for cards
  gray700: '#374151',        // gray-700
  gray800: '#1F2937',        // gray-800
  
  // Text colors
  dark: '#111827',           // gray-900 for dark text
  text: '#1F2937',           // gray-800 for readable dark text
  textSecondary: '#6B7280',  // gray-500 for secondary text
  textDark: '#6B7280',       // gray-600 for secondary text
  textMuted: '#9CA3AF',      // gray-400 for muted text
  muted: '#D1D5DB',          // gray-300 for light muted text
  white: '#FFFFFF',
  
  // Status colors
  error: '#DC2626',          // red-600 for errors
  success: '#16A34A',        // green-600 for success
  warning: '#D97706',        // amber-600 for warnings
  info: '#2563EB',           // blue-600 for info
  
  // UI colors
  lightGray: '#F3F4F6',      // gray-100
  border: '#E5E7EB',         // gray-200
  shadow: 'rgba(0, 0, 0, 0.2)',
  buttonPrimary: '#14B8A6',  // teal-500 button
  buttonSecondary: '#0F172A', // slate-900 button
  
  // Accent colors
  red: '#EF4444',            // red-500 for seeker theme
  teal: '#14B8A6',           // teal-500
  slate: '#0F172A',          // slate-900
};